// O APK "Print Control Admin" usa o mesmo build web do app, mas o
// capacitor.config.json dele acrescenta esta marca ao user agent
// (ver scripts/build-admin-apk.cjs). Com ela, o app abre só o suporte.
export const MARCA_APP_ADMIN = "PrintControlAdmin";

export function ehAppAdmin(userAgent = typeof navigator === "undefined" ? "" : navigator.userAgent) {
  return String(userAgent || "").includes(MARCA_APP_ADMIN);
}
